import { merge } from '../helper';

// ----------------------------------------------------------------------------

interface ObserverConfig {
    attributes?: boolean;
    childList?: boolean;
    characterData?: boolean;
    fnCallback?: (mutation: MutationRecord, observer: MutationObserver) => void;
}

// ----------------------------------------------------------------------------

function observer(element: HTMLElement | string, config: ObserverConfig = {}): MutationObserver {
    // Default Config
    const defConfig: ObserverConfig = {
        attributes: true,
        childList: true,
    };

    // Merge
    merge(defConfig, config);

    // --------------------------------------------------------------------

    // Get the element
    const elTargetNode = typeof element === 'string' ? document.querySelector(element) : element;

    if (!(elTargetNode instanceof HTMLElement)) {
        throw new Error('observer: Target element not found or invalid.');
    }

    // Create observer callback
    const fnCallback = (mutations: MutationRecord[], obs: MutationObserver): void => {
        if (typeof defConfig.fnCallback === 'function') {
            for (const mutation of mutations) {
                defConfig.fnCallback.call(elTargetNode, mutation, obs);
            }
        }
    };

    // Create and start observer
    const obs = new MutationObserver(fnCallback);
    obs.observe(elTargetNode, defConfig);

    return obs;
}

// ----------------------------------------------------------------------------

export default observer;
